var app = angular.module('leonardo');

var ChatReactController = function($scope, $element, AccountUserService, ConfigThemeService, AuthService, FilterService,
                                   AccountService, PermissionService) {


  $scope.loadReact = function() {
    $scope.token = AuthService.getDecodedToken();
    if (!PermissionService.permissionAvailableAccount('permission_live_chat', true) ||
      !$scope.token.stream_chat_token || !$element.find('#react-chat-view')[0]) {
      ReactDOM.unmountComponentAtNode(document.getElementById('react-chat-view'));
      return;
    }
    var el = React.createElement(window.LeoChatScreen,
      {
        accounts: AccountService.getCollection(),
        chatToken: $scope.token.stream_chat_token,
        apiKey: $scope.token.stream_key,
        currentAccountUser: AccountUserService.getAccountUser(FilterService.getFilter('account')),
        configTheme: {config: ConfigThemeService.config, updated: ConfigThemeService.updated},
      });
    ReactDOM.render(el, $element.find('#react-chat-view')[0]);
  };

  $scope.loadReact();

  $scope.$on('auth-data:updated', function () {
    $scope.loadReact();
  });
  angular.forEach(['property:added', 'property:updated', 'property:moved', 'property:deleted'], function (event) {
    $scope.$on(event, function (e) {
      ReactDOM.unmountComponentAtNode(document.getElementById('react-chat-view'));
      $scope.loadReact();
    });
  });

  $scope.$on('$destroy', function() {
    ReactDOM.unmountComponentAtNode(document.getElementById('react-chat-view'));
  });

};
app.controller('ChatReactController', ['$scope', '$element', 'AccountUserService', 'ConfigThemeService', 'AuthService',
    'FilterService', 'AccountService', 'PermissionService', ChatReactController]);
